import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface OpeningSoonOverlayProps {
  onClose?: () => void;
}

export function OpeningSoonOverlay({ onClose }: OpeningSoonOverlayProps) {
  const { t } = useTranslation();

  // Blokovat scrollování při zobrazení overlay
  useEffect(() => {
    // Uložit původní overflow hodnotu
    const originalOverflow = document.body.style.overflow;
    const originalOverflowHtml = document.documentElement.style.overflow;

    // Nastavit overflow-hidden na body a html
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // Cleanup při unmount
    return () => {
      document.body.style.overflow = originalOverflow;
      document.documentElement.style.overflow = originalOverflowHtml;
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-boho-cream via-boho-beige to-boho-warm backdrop-blur-2xl flex items-center justify-center h-screen w-screen overflow-hidden">
      <div className="max-w-2xl w-full text-center px-4">
        {/* Logo - malé */}
        <div className="mb-8 flex justify-center">
          <img
            src="/logo-posterden.png"
            alt="POSTER'S DEN Logo"
            className="h-24 w-auto md:h-32"
          />
        </div>

        {/* Text */}
        <div className="mb-8">
          <h1 className="text-4xl md:text-6xl font-bold text-boho-dark mb-4">
            {t('openingSoon.title')}
          </h1>
          <p className="text-xl md:text-2xl text-boho-dark/80">
            {t('openingSoon.notSelling')}
          </p>
        </div>

        {/* Tlačítko zpátky do konfigurátoru */}
        {onClose && (
          <button
            onClick={onClose}
            className="px-8 py-3 bg-posterden-red hover:bg-posterden-dark text-white font-semibold rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
          >
            {t('openingSoon.backToConfigurator')}
          </button>
        )}
      </div>
    </div>
  );
}
